import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CONSENT_EVENT, getConsent } from "../lib/consent";
import { grantPixelConsent, isPrivatePath, loadPixel, revokePixelConsent, trackPageView, trackSchedule } from "../lib/tiktokPixel";

export default function TikTokPixel() {
  const { pathname } = useLocation();
  const [marketing, setMarketing] = useState(() => Boolean(getConsent()?.marketing));

  useEffect(() => {
    const onChange = (e) => setMarketing(Boolean(e.detail?.marketing));
    window.addEventListener(CONSENT_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_EVENT, onChange);
  }, []);

  useEffect(() => {
    if (marketing) {
      loadPixel();
      grantPixelConsent();
    } else {
      revokePixelConsent();
    }
  }, [marketing]);

  useEffect(() => {
    if (!marketing || isPrivatePath(pathname)) return;
    trackPageView();
  }, [marketing, pathname]);

  useEffect(() => {
    if (!marketing) return;
    const onMessage = (e) => {
      if (e.origin !== "https://calendly.com" || e.data?.event !== "calendly.event_scheduled") return;
      const uri = e.data.payload?.invitee?.uri || e.data.payload?.event?.uri || "";
      trackSchedule(uri);
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [marketing]);

  return null;
}
